import { noParamsReducer } from 'react-async-client';
import { filter, contains, length, prop } from 'ramda';

import {
    LOGOUT,
    CANCEL_REQUEST,
    APPROVE_PERSON,
    REJECT_PERSON,
    APPROVE_PROJECT,
    REJECT_PROJECT
} from 'constants/actionTypes';

const ApprovalListCustomReducer = (field) => (state, { payload: {ids} }) => ({
    ...state,
    [field]: filter((item) => !contains(item.id, ids), state[field] || [])
});
const ApprovalCountersCustomReducer = (state, { type, payload }) => {
    const counts = length(prop('ids', payload || {}));

    switch(type) {
        case CANCEL_REQUEST:
            return { ...state, inwork: state.inwork - counts, canceled: state.canceled + counts };
        case APPROVE_PERSON:
        case APPROVE_PROJECT:
            return { ...state, inwork: state.inwork - counts, approved: state.approved + counts };
        case REJECT_PERSON:
        case REJECT_PROJECT:
            return { ...state, inwork: state.inwork - counts, rejected: state.approved + counts };
        case LOGOUT:
            return {};
        default:
            return state;
    }
}

export const approvalsReducer = {
    request: {
        list: noParamsReducer(ApprovalListCustomReducer('request'), [CANCEL_REQUEST]),
        counters: noParamsReducer(ApprovalCountersCustomReducer, [LOGOUT, CANCEL_REQUEST])
    },
    person: {
        list: noParamsReducer(ApprovalListCustomReducer('approval'), [APPROVE_PERSON, REJECT_PERSON]),
        counters: noParamsReducer(ApprovalCountersCustomReducer, [LOGOUT, APPROVE_PERSON, REJECT_PERSON])
    },
    project: {
        list: noParamsReducer(ApprovalListCustomReducer('project'), [APPROVE_PROJECT, REJECT_PROJECT]),
        counters: noParamsReducer(ApprovalCountersCustomReducer, [LOGOUT, APPROVE_PROJECT, REJECT_PROJECT])
    }
}
